<template>
<div class="container">
     <CalculationTab :stockHandler="stockData" :calculationCallback="calculate" />

</div>
</template>

<script>
import axios from 'axios';
import CalculationTab from '@/components/CalculationTab.vue';
export default {
  name: 'App',
  components: {
    CalculationTab,
  },
  data() {
    return {
      stockData: [],

    }
  },
  methods: {
      async processData() {
      console.log('开始请求数据:', this.questionQuery);
      try {
        const now = new Date();
        const dateString = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
        const now_date = dateString;
        console.log('当前时间:', now_date);
        const responses = await  axios.get(`/api/processData`,{ params: { now_date: now_date } });
        const responseData = responses.data;
        console.info(responseData);
        alert(responseData.data.length);
        console.log('所有请求完成:', responseData); // 添加调试信息
      } catch (error) {
        console.error('请求失败:', error);
      }
    },

    calculate(formattedBuyPrice, formattedSellPrice, formattedOptionRate,formattedKnockOutPrice){
        const BuyPrice=formattedBuyPrice
        const SellPrice=formattedSellPrice
        const OptionRate=formattedOptionRate
        const KnockOutPrice=formattedKnockOutPrice
        const total = 1000000
        const fee = 0.01
        const fee_total = 0.2
        const fee_amount =  ((fee * OptionRate * total) + fee_total).toFixed(2)
        const amount = (SellPrice- BuyPrice) / BuyPrice
        const earnings = (amount * total).toFixed(2)
        const profit = (earnings - fee_amount).toFixed(2)
        const funds_fee = ((profit / fee_amount) * 100).toFixed(2)

        const knock_out_earnings =((KnockOutPrice - BuyPrice) / BuyPrice * total).toFixed(2)
        const knock_out_profit = (knock_out_earnings - fee_amount).toFixed(2)
        const knock_out_funds_fee =((knock_out_profit / fee_amount) * 100).toFixed(2)

        const js=(1+(parseFloat(OptionRate) + parseFloat(fee_total))/100)*BuyPrice
        const results = [
            {
                "持仓成本": (fee_amount/10000).toFixed(2)+ "万元",
                "持仓股数": (total / BuyPrice).toFixed(2),
                "回本价格": js.toFixed(2) + "元",
                "标的涨幅": (amount*100).toFixed(2) + "%"
            },
            {
                "期末收益": (earnings/10000).toFixed(2)+ "万元",
                "净收益": (profit/10000).toFixed(2)+ "万元",
                "收益率": funds_fee+ "%",
            },
            {
                "敲出收益": (knock_out_earnings/10000).toFixed(2)+ "元",
                "敲出净收益":(knock_out_profit/10000).toFixed(2)+ "元",
                "敲出收益率": knock_out_funds_fee + "%"
            }
        ];
        return results;
    },
  },
}
</script>